import DashboardLayoutHeader from 'components/layout/dashboardLayoutHeader/DashboardLayoutHeader';
import { Outlet } from 'react-router-dom';
import { useAtom } from 'jotai';
import { NavbarState } from 'stores/atoms/navbarState';
import SettingLayoutNavbar from './SettingLayoutNavbar';

import type { JSX } from 'react';

/**
 * ワークスペースのレイアウト定義
 */
export default function SettingLayout(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [navbarState, setNavbarState] = useAtom(NavbarState);

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * スマートフォンレイアウト時のナビゲーションバーを閉じます
   */
  const onSpNavbarClose = () => {
    if (navbarState.open) {
      setNavbarState({ open: false });
    }
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <main>
      <DashboardLayoutHeader />
      <SettingLayoutNavbar />
      <div
        onClick={onSpNavbarClose}
        className={`col-main ${navbarState.open ? 'body-with-overlay' : ''}`}
      >
        <Outlet />
      </div>
    </main>
  );
}
